import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toArray, isObjectEmpty, buildUniqueArrayFromField} from '../../../Utils';
import {pipe, map, filter, sort, toTime, toTimeType} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    function getTableData(){    
        const {summaryData, classData, studentData} = pageState;
        if(isObjectEmpty(summaryData)) return;
        
        let classIDList = buildUniqueArrayFromField(toArray(summaryData), 'classID');
        let classList = pipe(
            map(classID => classData[classID]),
            filter(classRec => classRec),
            sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() === b.Classname.toUpperCase() ? -1 : 0)),
        )(classIDList); 
                    
        let studentsPerClass = classList.map(classRec => { return {classRec,
            students: summaryData.filter(summaryRec=> 
                summaryRec.classID===classRec.ClassID).map(summaryMark=>{
                    let title = '';
                    if(studentData[summaryMark.StudentID])
                        title = studentData[summaryMark.StudentID].Name;
                    return {...summaryMark, 
                        QuestionsRight: parseInt(summaryMark.QuestionsRight),
                        QuestionsAttempted: parseInt(summaryMark.QuestionsAttempted),
                        time: parseInt(summaryMark.CumulativeTime) + parseInt(summaryMark.CumulativeIdleTime),
                        percent: Math.round(parseInt(summaryMark.QuestionsRight)/ parseInt(summaryMark.QuestionsAttempted)*100),
                        correct: summaryMark.QuestionsRight + ' / ' + summaryMark.QuestionsAttempted,
                        logins: 1,
                        title  
                    };
                }).reduce((acc, item) => { // merge dulicates
                    let found = (acc.find(e => e.StudentID === item.StudentID));
                    !found && acc.push(item);
                    if(found){
                        found.QuestionsRight += item.QuestionsRight;
                        found.QuestionsAttempted += item.QuestionsAttempted;
                        found.time += item.time; 
                        found.correct = found.QuestionsRight + ' / ' + found.QuestionsAttempted;
                        found.percent = Math.round(found.QuestionsRight/found.QuestionsAttempted*100);
                        found.logins ++;
                    }
                    return acc;
                },[])
            };}
        ).reduce((obj, item) => { // create a dictionary of classIDs and student lists
                obj[item.classRec.ClassID] = {students:item.students,
                    combined: item.students.reduce((acc, studRec)=>{
                        acc.QuestionsRight += studRec.QuestionsRight;
                        acc.QuestionsAttempted += studRec.QuestionsAttempted;
                        acc.time += studRec.time; 
                        acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
                        acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
                        acc.logins += studRec.logins;
                        return acc;
                    },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0})
                };
                return obj; 
            },{});

        classList = classList.filter( classRec => // only care about classes with marks
            classIDList.indexOf(classRec.ClassID) > -1
        );

        classList = classList.map( classRec => { 
            return {...classRec, studentData: [...studentsPerClass[classRec.ClassID].students], combinedData: studentsPerClass[classRec.ClassID].combined};
        });

        return classList;
    }
    
    return <><StudentClassesComp tableData={getTableData()} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const StudentClassesComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col  style={{textAlign: 'left'}} xs='4'>Classes/Students</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Logins</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions Correct</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Percent</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}
            {titleRow}
            {tableData.map((classRec, stud_i) => <span key={stud_i}>
                <Row><Col xs='12' style={{fontWeight:'bold'}} >{classRec.Classname}</Col></Row>
                {classRec.studentData.map((studentRec, stud_i) => 
                    <ProgramRow key={stud_i} data={studentRec} fontWeight={'normal'}/>
                )}
                <ProgramRow data={{name:'', logins: classRec.combinedData.logins, correct: classRec.combinedData.correct, percent:classRec.combinedData.percent, time:classRec.combinedData.time}} fontWeight={'bold'}/>
                </span>
            )}

            <Row><Col xs='12'></Col></Row>
            <ProgramRow data={{title: 'Total', logins: totals.logins, correct: totals.correct, percent:totals.percent, time:totals.time}} fontWeight={'bold'}/>

        </Container>
    );
};
StudentClassesComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const { title, logins, correct, percent, time} = props.data;

    return (
        <Row>
            <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='4'>{title}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{logins}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{correct}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{isNaN(percent)?'-':`${percent}%`}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(time)} {toTimeType(time)}</Col>
        </Row>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
